(ns dre.modals.usage.events
  (:require
   [applied-science.js-interop :as j]
   ["dom-to-image-more" :as domtoimage]
   ["exceljs" :as excel]
   [clojure.walk :as walk]
   [cljs.core.async :refer [go]]
   [cljs.core.async.interop :refer-macros [<p!]]
   [clojure.string :as str]
   [day8.re-frame.tracing :refer-macros [fn-traced]]
   [dre.app.router :as router :refer [->route ->route-with-query-params]]
   [dre.components.pill :as pill-component]
   [dre.fx :as-alias dre.fx]
   [dre.modals.events :as-alias modals]
   [dre.network :as-alias network]
   [dre.pages.admin.usage.events :as usage-events]
   [dre.shared.interface.search.blunt :as blunt]
   [dre.shared.interface.search.pills :as pills-util]
   [dre.utils.query :as q]
   [dre.utils :refer [stringify-keys-with-namespaces]]
   [re-frame.core :as rf]
   [reagent.dom :as dom]
   [superstructor.re-frame.fetch-fx :as-alias fetch-fx]))

(def db-path
  [:modals :usage])

(defn- postprocess-and-save [row-number row-count wb worksheet]
  (go
    (let [row (j/call worksheet :getRow row-number)
          query-cell (j/call row :getCell "query")
          pills (walk/keywordize-keys (js->clj (j/get query-cell :value)))
          image-render-element (j/call js/document :getElementById "usage-export-img-placeholder")
          progress-render-element (j/call js/document :getElementById "usage-export-progress-placeholder")
          _ (dom/render [:span "Writing record " (dec row-number) "/" (dec row-count) " to excel file:"] progress-render-element)
          _ (dom/render [pill-component/readonly-pills pills nil nil nil {:hide-controls? true}] image-render-element)
          wr 1
          hr 1
          _ (j/assoc! row :height (* hr (j/get image-render-element :offsetHeight)))
          blob (<p! (domtoimage/toBlob image-render-element #js {}))
          base64-converter (fn [blob]
                             (new js/Promise (fn [reslove _]
                                               (let [file-reader (js/FileReader.)
                                                     _ (j/assoc! file-reader :onloadend
                                                                 (fn [evt]
                                                                   (let [base-64 (-> evt .-target .-result)]
                                                                     (reslove base-64))))]
                                                 (j/call file-reader :readAsDataURL blob)))))
          base-64 (<p! (base64-converter blob))
          image-id (j/call wb :addImage (clj->js {:base64 base-64 :extension "png"}))]
      (j/assoc! query-cell :value "")
      (j/call worksheet :addImage image-id (clj->js {:tl {:col (- (j/get query-cell :col) 1) :row (- (j/get query-cell :row) 1)}
                                                     :ext {:width (* wr (j/get image-render-element :offsetWidth))
                                                           :height (* hr (j/get image-render-element :offsetHeight))}}))
      (if (<= row-count row-number)
        (.then (j/call (j/get wb :xlsx) :writeBuffer)
               #(do (rf/dispatch [::dre.fx/download {:content %
                                                     :filename "usage-report.xlsx"
                                                     :mimetype "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"}])
                    (rf/dispatch [::clear])))
        (postprocess-and-save (inc row-number) row-count wb worksheet)))))

;; events
(rf/reg-event-fx
 ::init
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [{db :db} [filters]]
  (let [workbook (.-Workbook excel)
        wb (workbook.)
        worksheet (j/call wb :addWorksheet "Usage report")
        _ (j/assoc! worksheet :columns (into-array [(clj->js {:header "Time" :key "time" :width 14})
                                                    (clj->js {:header "Email" :key "email" :width 20})
                                                    (clj->js {:header "Client" :key "client" :width 20})
                                                    (clj->js {:header "BAQ?" :key "baq?" :width 10})
                                                    (clj->js {:header "BAQ Topics" :key "baq-topics" :width 50})
                                                    (clj->js {:header "LS link" :key "link" :width 10})
                                                    (clj->js {:header "Query" :key "query" :width 10})]))]
    {:db {:settings
          {:anonymize false}
          :filters filters
          :state nil
          :progress nil
          :worksheet worksheet
          :workbook wb}})))

(rf/reg-event-fx
 ::clear
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [{db :db} [_]]
  {:dispatch [::modals/clear]}))

(rf/reg-event-fx
 ::set-settings
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [{db :db} [k v]]
  {:db (assoc-in db [:settings k] v)}))

(rf/reg-event-fx
 ::export
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [{db :db} [{:keys [pagination] :as opts}]]
  (let [default-pagination {:limit 50
                            :offset 0}
        pagination (merge default-pagination pagination)
        updated-opts (assoc opts :pagination pagination)
        params (usage-events/->query-params (:filters db) pagination :events)]
    {:db  (assoc db :state :loading)
     :fx [[::network/request-with-abort [{:endpoint :admin/usage.events}
                                         {:response-content-type :json
                                          :params params
                                          :on-success [::export-on-ok updated-opts]
                                          :on-failure [::export-on-nok updated-opts]}]]]})))

(rf/reg-event-fx
 ::export-on-ok
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [{db :db} [{::fetch-fx/keys [response]
              :keys [pagination] :as opts}]]
  (let [data (map (fn [{:keys [_created username profile payload offset limit search-meta]}]
                    {:time _created
                     :email username
                     :baq (get search-meta :query/baq)
                     :client (:client profile)
                     :pills (when-let [pills (pills-util/coerce payload)]
                              (let [pill (pills-util/flats->pill pills)
                                    normalized (pills-util/normalize pill)
                                    flats (pills-util/pills->flats [normalized])]
                                flats))
                     :from (inc offset)
                     :to (+ offset limit)}) (:events (:body response)))
        _ (doseq [record data]
            (j/call (:worksheet db) :addRow (clj->js {:time (:time record)
                                                      :email (if (get-in db [:settings :anonymize])
                                                               "*****"
                                                               (:email record))
                                                      :client  (if (get-in db [:settings :anonymize])
                                                                 "*****"
                                                                 (:client record))
                                                      :link (let [search-query {:query/type :articles
                                                                                :query/pills (:pills record)}
                                                                  route (->route-with-query-params (->route :search) (:query-params (q/route search-query nil)))
                                                                  base-url (j/get-in js/window [:window :location :origin])
                                                                  url (str base-url route)]
                                                              {:formula (str "HYPERLINK(\"" url "\")")})
                                                      :query (stringify-keys-with-namespaces (:pills record))
                                                      :baq? (if (not (nil? (:baq record)))
                                                              "Yes"
                                                              "No")
                                                      :baq-topics (when (not (nil? (:baq record)))
                                                                    (str "Topic: " (get-in record [:baq :topic]) "\n\n"
                                                                         (str/join "\n" (map #(str (:type %) ":" (if (str/blank? (:blunt %))
                                                                                                                   "N/A"
                                                                                                                   (str/join "," (map (fn [pill]
                                                                                                                                        (if (= (:pill/type pill) :text)
                                                                                                                                          (:pill/query pill)
                                                                                                                                          (:pill/label pill))) (blunt/parse (:blunt %))))))
                                                                                             (get-in record [:baq :categories])))))})))]
    {:db (-> db
             (assoc :progress {:total (:count (:body response))
                               :processed (+ (:offset pagination) (:limit pagination))}))
     :dispatch (if (>
                    (+ (:offset pagination) (:limit pagination))
                    (min 2000 (:count (:body response))))
                 [::generate-report]
                 [::export {:pagination {:offset (+ (:offset pagination) (:limit pagination))}}])})))

(rf/reg-event-fx
 ::export-on-nok
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [{db :db} [{::fetch-fx/keys [response]
              :keys [_]}]]
  {:db (-> (assoc db :export-data nil)
           (assoc :state :failure))
   :dispatch [:dre.network/default-failure {:event :admin-usage-export}]}))

(rf/reg-event-fx
 ::generate-report
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [{db :db} [_]]
  (let [row-count (j/get (:worksheet db) :rowCount)]
    (postprocess-and-save 2 row-count (:workbook db) (:worksheet db))
    nil)))


;; subscriptions

(rf/reg-sub
 ::state
 (fn [db _]
   (get-in db db-path)))


